import { useEffect } from 'react';
import { initTrackingScripts, refreshTrackingScripts } from '../../utils/trackingScripts';

/**
 * Loads third-party analytics/marketing scripts after cookie consent is resolved.
 */
const TrackingScripts = () => {
  useEffect(() => {
    initTrackingScripts();

    const handlePreferencesChanged = () => {
      refreshTrackingScripts();
    };

    window.addEventListener('cookiePreferencesChanged', handlePreferencesChanged);
    return () => {
      window.removeEventListener('cookiePreferencesChanged', handlePreferencesChanged);
    };
  }, []);

  return null;
};

export default TrackingScripts;
